export const pVPurpleBase = '#7c24ce';
export const pVLightPurpleBars = '#ebe5f0';
export const pVDarkPurple = '#6320a0';
export const pVBlueLight = '#009bef';
export const pVBlueNavBar = '#175d8d';
export const pVGrayLightNavBar = '#f5f5f5';
export const pVListignsCoolGray = '#deedf7';
export const pVOrange3 = '#FF7832';
export const pVOrangeText = '#FF6600';
export const pVSiloNameBlue = '#047cc0';
export const pVBlue3 = '#5AAAFA';
export const pVBlue4 = '#0094FF';
export const pVGreenLabelOn = '#1BCC00';
export const pVYellow = '#EFB810';
export const pVYellow2 = '#EFC100';

export const pVRouteDelayedRed = '#FF1717';

export const darkGray = '#969696';
export const mediumGray = '#c8c8c8';
export const lightGray = '#e0e0e0';
export const lightGrayTwo = '#c8d2d2';
export const lightGrayThree = '#f8fafc';

export const GRAPH_COLORS_DICTIONARY = {
  '100M': ['rgba(140,40,254,1)', 'rgba(65,0,149,1)', 'rgba(211,173,254,1)'],
  100: ['rgba(140,40,254,1)', 'rgba(65,0,149,1)', 'rgba(211,173,254,1)'],
  '30/50': ['rgba(0,165,255,1)', 'rgba(0,82,139,1)', 'rgba(169,254,255,1)'],
  '40/70': ['rgba(255,49,155,1)', 'rgba(166,38,110,1)', 'rgba(255,163,210,1)'],
  '16/30': ['rgba(254,213,0,1)', 'rgba(198,162,26,1)', 'rgba(255,242,176,1)'],
  '20/40': ['rgba(255,147,0,1)', 'rgba(185,107,1,1)', 'rgba(255,175,122,1)'],
  '200M': ['rgba(1,210,90,1)', 'rgba(0,136,75,1)', 'rgba(164,232,193,1)'],
  200: ['rgba(1,210,90,1)', 'rgba(0,136,75,1)', 'rgba(164,232,193,1)'],
  '12/20': ['rgba(89,245,178,1)', 'rgba(94,207,162,1)', 'rgba(167,255,217,1)'],
  '30/70': ['rgba(0,165,255,1)', 'rgba(0,82,139,1)', 'rgba(151,218,255,1)'],
  extra: ['rgba(1,230,233,1)', 'rgba(0,157,176,1)', 'rgba(255,159,142,1)']
};

export const graphColors = [
  '#FF5003',
  '#BE9B00',
  '#5596E6',
  '#5ECFA2',
  '#9855D4',
  '#5AA700',
  '#4D70A7',
  '#FF6633',
  '#FFB399',
  '#FF33FF',
  '#00B3E6',
  '#E6B333',
  '#3366E6',
  '#999966',
  '#B34D4D',
  '#80B300',
  '#809900',
  '#E6B3B3',
  '#6680B3',
  '#66991A',
  '#FF99E6',
  '#FF1A66',
  '#E6331A',
  '#33FFCC',
  '#66994D',
  '#B366CC',
  '#4D8000',
  '#B33300',
  '#CC80CC',
  '#66664D',
  '#991AFF',
  '#E666FF',
  '#4DB3FF',
  '#1AB399',
  '#E666B3',
  '#33991A',
  '#CC9999',
  '#B3B31A',
  '#00E680',
  '#4D8066',
  '#809980',
  '#E6FF80',
  '#1AFF33',
  '#999933',
  '#FF3380',
  '#CCCC00',
  '#66E64D',
  '#4D80CC',
  '#9900B3',
  '#E64D66',
  '#4DB380',
  '#FF4D4D',
  '#99E6E6',
  '#6666FF'
];

export const pulseChartColors = [
  '#E3BC13',
  '#009BEF',
  '#D54081',
  '#81B532',
  '#5A3EC8',
  '#40D5BB',
  '#FF6600',
  '#90A49B',
  '#D54081',
  '#D5D040',
  '#A340D5',
  '#40D560',
  '#FFAA00',
  '#1173A7',
  '#FF0000',
  '#63882A',
  '#9382D7',
  '#C9BAE5',
  '#FA9A82',
  '#986590',
  '#CE95AE',
  '#A9A301',
  '#3277D8',
  '#33ABA9'
];

export const btnsColors = {
  blue: 'blue',
  navyBlue: 'navyBlue',
  red: 'red',
  orange: 'orange',
  green: 'green',
  transparent: 'transparent',
  blueTransparent: 'blueTransparent',
  redTransparent: 'redTransparent',
  disabled: 'disabled'
};
